import { Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

const Container = styled('div')({
    zIndex: 2,
    position: "relative",
    height: "100vh",
});

const Page = styled('div')(({ theme }) => ({
    backgroundSize: "cover",
    backgroundPosition: "top center",
    height: "100vh",
}));

const PageHeader = styled('div')(({ theme }) => ({
    margin: "0",
    padding: "0",
    border: "0",
    height: "100vh"
}));

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    fullView?: boolean;
}

type Props = IAppProps & React.PropsWithChildren;

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BlankLayout: React.FC<Props> = (props) => {

    const location = useLocation();
    const [currentPath, setCurrentPath] = useState("");

    const mainPanel = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (location.pathname !== currentPath) {
            setCurrentPath(location.pathname);
            if (mainPanel && mainPanel.current) mainPanel.current.scrollTop = 0;
        }
    }, [currentPath, mainPanel, location.pathname]);

    return (
        <Page ref={mainPanel}>
            <PageHeader>
                <Container>
                    <Grid container justifyContent="center" style={{ minHeight: "100vh" }} >
                        <Grid size="grow">
                            <Outlet />
                        </Grid>
                    </Grid>
                </Container>
            </PageHeader>
        </Page>
    );
};
